<template>
    <div class="pSearchAndCareerSearch">
        <div class="main">
            <!--专业信息库-->
            <div>
                <div style="min-height: 500px;" class="container-left position-relative">
                    <div    v-show="professionDetailType.length>0&&!loadingData">
                        <div class="flex">
                            <div v-for="item in radioCategoryList"
                                 :key="item.levelId"
                                 class="title cursorSz padding-x"
                                 :class="radioCategory===item.levelName?'activePr':''"
                                 @click="selectLevel(item.levelName)">
                                {{item.levelName}}专业分类
                            </div>
                        </div>
                        <div class="line">
                        </div>
                        <div class="position-relative">
                            <div style="margin-right:200px;">
                                <div v-for="item in professionDetailType"
                                     :name="item.className"
                                     class="margin-top commonBackground"
                                     :key="item.classCode">
                                    <h3 class="titleF border-bottom padding-small padding-left ">
                                         <img width="20" height="20" class="vertical-middle" v-lazy="item.icon" alt="">
                                        <span class="vertical-middle font-weight-bolder text-m-size">
                                            {{item.className+'['+item.classCode+']'}}
                                        </span>
                                    </h3>
                                    <div v-for="itemCategory in item.majorCategory" :key="itemCategory.code">
                                        <div class="titleS marginSmallY  padding-left font-weight-bolder">
                                           {{itemCategory.name+'('+itemCategory.code+')'}}
                                        </div>
                                        <el-row :gutter="20" class="padding-small padding-left">
                                            <el-col :span="4" v-for="itemMajors in itemCategory.majors"
                                                    @click.native="lookDetail(itemMajors )" :key="itemMajors.id" >
                                                <div v-if="itemMajors.majorName.length<7" class="professionNameC cursorSz margin-bottom">
                                                    {{itemMajors.majorName}}
                                                </div>
                                                <el-tooltip :content="itemMajors.majorName" v-else>
                                                    <div class="text-ellipsis cursorSz margin-bottom professionNameC"  >
                                                        {{itemMajors.majorName}}
                                                    </div>
                                                </el-tooltip>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>
                            </div>
                            <div class="rightMenu position-absolute public_scroll_bar" :class="gudRightMenu?'gud':''">
                                <div v-for="item in professionDetailType"
                                     :class="activeProfession===item.className?'directoryActive':''"
                                     class="cursorSz margin-bottom padding-left"
                                     @click="selectType(item.className)"
                                     :key="item.classCode">
                                    {{item.className}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <loading :show="loadingData"></loading>
                </div>
            </div>
        </div>
        <common-target-router @clearHref="clearHref" :getLocation="getLocation"></common-target-router>
    </div>
</template>
<script>
    import {professionCategory} from "../../../config";
    export default {
        name: "professionalSearch",
        data(){
            return{
                loadingData:false,
                titleList:[],
                //获取选中的专业大类id
                selectTypeBigId:'',
                levelId:'',
                radioCategoryList:[],
                //获取此学历层次的专业分类
                professionDetailType:[],
                //获取大类下的子类
                professionSonType:[],
                selectTypeSonId:'',
                radioCategory:'',
                showOne:false,
                input3:'',
                professionalList:[],
                getLocation:'',
                gudRightMenu:false,
                //选择的专业
                activeProfession:''
            }
        },

        mounted(){
          this.professionCategory();
          window.onscroll=(()=>{
              if(window.pageYOffset>=62){
                  this.gudRightMenu=true;
              }else{
                  this.gudRightMenu=false;
              }
          })
        },
        beforeRouteLeave(to,from,next){
            window.onscroll=(()=>{
            })
            next();
        },
        methods:{
            clearHref(){
              this.getLocation='';
            },
            lookDetail(val){
                console.log(val);
                const {href} = this.$router.resolve(
                    {path:'/professionDetail',query:{professionId:val.id}});
                this.getLocation=href;
            },
            //选择顶部的专业类型
            selectType(val){
                this.activeProfession=val;
                let zhi=document.getElementsByName(val);
                console.log(zhi);
                console.log('我是' + val+'标签所在的y轴位置');
                // window.scrollTo(0,zhi[0].offsetTop-70);
                let top=zhi[0].offsetTop ;

                if(top===0){
                    window.scrollTo(0,0);
                    return false;
                }
                let offsetTops=0;
                let timer=setInterval(()=>{
                    var speed = top / 5;
                    if(offsetTops>=zhi[0].offsetTop ){
                        clearInterval(timer);
                    }else{
                        offsetTops+=speed;
                        window.scrollTo(0,offsetTops);
                    }
                },50)
            },
            //专业分类查询
            async professionCategory(){
                this.loadingData=true;
                let result=await professionCategory();
                if(result.status){
                    this.loadingData=false;
                    console.log(result.data);
                    this.titleList=result.data;
                    this.radioCategoryList=result.data;
                    this.radioCategory=result.data[0].levelName;
                    this.professionDetailType=result.data[0].majorClass;
                    this.activeProfession=this.professionDetailType[0].className;
                }else{
                    this.loadingData=false;
                }
            },
            //选择学历层次
            selectLevel(val){
                this.loadingData=true;
                this.professionDetailType=[];
                this.radioCategory=val;
                let zhi =this.radioCategoryList.filter((valFilter)=>{
                    return valFilter.levelName===val;
                });
                this.professionDetailType=zhi[0].majorClass;
                console.log(zhi);
                this.loadingData=false;
            },
        }
    }
</script>

<style scoped lang="scss">
    .pSearchAndCareerSearch {

        margin-top: 20px;


        .rightMenu{
            height:calc(100vh - 137px);


        }
        .main {
            margin: 0 32px;
            .container-top{
                height: 50px;
                .container-button{
                    width: max-content;

                    p{
                        padding: 3px 26px;
                    }
                }
                .container-right-input{

                    margin-left: 40px;
                }
            }
            .container-left{
                width: 100%;
                .title{

                    min-width: 162px;
                    height: 37px;
                    font-size: 16px;
                    line-height: 37px;
                    text-align: center;
                }
                .title.active{
                    color: #fff;
                    background: #0081cc;
                }

                .typeList{
                    z-index: 3;

                    height:40px;
                   >div{
                       border: 1px solid #e5e5e5;
                       background: linear-gradient(45deg, #b3b3b3, #ffffff);
                       line-height: 40px;
                       display: inline-block;
                   }
                }
                .typeList.zk{
                    height: 185px !important;
                }
                .bottom{
                    .titleF{
                        font-weight: bolder;
                        color: #ea4a0d;
                        font-size: 15px;
                    }
                    .titleF::before{
                        display: inline-block;
                        margin-right: 9px;
                        margin-bottom: -2px;
                        content:"";
                        background:#ea4a0d ;
                        height:15px;
                        width: 5px;
                        border-radius: 1px;
                    }
                    .titleS{
                        padding: 3px 0 3px 12px;
                        font-weight: bolder;
                        background: #e5e5e5;
                    }
                    .el-row{
                        .el-col{
                            margin-bottom: 5px;
                            color: #00a1ff;
                            cursor: pointer;
                        }
                    }
                }
            }

        }
    }

</style>
